/** Исходные данные операции — проводка в том виде, в каком пришла из источника (1С): счёт и субконто */

const ACCOUNT_CODES = {
  "Денежные средства в кассе": "1010",
  "Основные средства": "2410",
  "Амортизация основных средств": "2420",
  "Обязательства по налогам сотрудников": "3120",
  "Задолженность сотрудникам": "3350",
  "Нераспределенная прибыль": "5510",
};

/** В 1С у счёта не больше трёх субконто */
export const MAX_SUBCONTO = 3;

export const getAccountCode = (accountName) => ACCOUNT_CODES[accountName] || null;

/** Субконто стороны проводки в формате [{ label, value }] */
export const getSubconto = (row, suffix) =>
  (row[`analytics${suffix}`] || [])
    .slice(0, MAX_SUBCONTO)
    .map((item, index) => ({ label: `Субконто ${index + 1}`, value: item.value }));
